import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../apollo-client';
import {appHistory} from '../../../../history';
import {store} from '../../../../store';

import {RoleTableWrapper} from './role-table-wrapper';
import {StatusTableWrapper} from './status-table-wrapper';

const USERS_TABLE_REACT_MOUNT_ID = 'users-table-react-mount';

export function mountUsersTable() {
    const mount = document.getElementById(USERS_TABLE_REACT_MOUNT_ID);
    const statusFilter = mount && mount.dataset.status;
    const roleId = mount && mount.dataset.roleid;

    if (mount && (statusFilter || roleId)) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            {statusFilter ? (
                                <StatusTableWrapper statusFilter={statusFilter} />
                            ) : (
                                // This will exist because of the check above, but defaulting to empty string for flow
                                <RoleTableWrapper id={roleId || ''} />
                            )}
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mount
        );
    }
}
